export const MAX_PHONE_DIGITS = 10;

/**
 * Validates the structural format of an email address.
 * Performs basic validation to ensure the email contains '@' and a domain.
 */
export function validateEmail(val: string): boolean {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(val.trim());
}

/**
 * Strips all non-digit characters from a phone number string.
 * Removes spaces, dashes, parentheses, and any other non-numeric characters.
 * @example
 * normalizePhone("(555) 123-4567") // returns "5551234567"
 */
export function normalizePhone(val: string): string {
	return val.replace(/[^0-9]/g, '');
}

/**
 * Formats numeric digits into a US phone number display format.
 * Applies formatting progressively as digits are entered: (XXX) XXX-XXXX
 * @example
 * formatPhoneDisplay("555") // returns "555"
 * formatPhoneDisplay("5551234") // returns "(555) 1234"
 * formatPhoneDisplay("5551234567") // returns "(555) 123-4567"
 */
export function formatPhoneDisplay(digits: string): string {
	if (digits.length <= 3) return digits;
	if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/**
 * Validates that a phone number contains exactly the required number of digits.
 * Strips non-numeric characters before validation.
 * validatePhone("(555) 123-4567") // returns true
 * validatePhone("555-1234") // returns false (only 7 digits)
 */
export function validatePhone(val: string): boolean {
	const digits = normalizePhone(val);
	return digits.length === MAX_PHONE_DIGITS;
}
